"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.topBarStyles = void 0;
const lit_1 = require("lit");
const shared_styles_1 = require("@/stylesheets/shared.styles");
exports.topBarStyles = (0, lit_1.css) `
  :host {
    --top-bar-min-height: var(--size-48);
    --top-bar-gap: var(--space-2);

    display: block;
    background: inherit;
  }

  /* 페이지 단위 상단 바라 높이를 스스로 갖고 배경은 부모를 따른다. 고정 위치는 mm-fixed-top이 맡는다. */
  header {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: var(--top-bar-min-height);
    gap: var(--top-bar-gap);
    box-sizing: border-box;
    background: inherit;
    ${shared_styles_1.layerContainerStyles};
  }

  /* 재질은 ::before 형제 레이어가 소유한다. 조상에 backdrop-filter가 걸리면 action slot 안 popover의 blur가 죽기 때문이다. */
  header::before {
    background: inherit;
    backdrop-filter: var(--material-chrome-backdrop-filter);
    -webkit-backdrop-filter: var(--material-chrome-backdrop-filter);
    ${shared_styles_1.backgroundLayerStyles};
  }

  .trailing-area {
    display: flex;
    gap: var(--top-bar-gap);
    margin: 0 0 0 auto;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9wLWJhci5zdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0b3AtYmFyLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBeUI7QUFFekIsK0RBQXlGO0FBRTVFLFFBQUEsWUFBWSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7TUFrQnpCLG9DQUFvQjs7Ozs7Ozs7TUFRcEIscUNBQXFCOzs7Ozs7OztDQVExQixDQUFBIn0=